import { useCallback, useState } from 'react'

const useModal = () => {
  const [open, setOpen] = useState(false)

  const closeModal: VoidFunction = useCallback(() => {
    setOpen(false)
  }, [])
  const openModal: VoidFunction = useCallback(() => {
    setOpen(true)
  }, [])

  return {
    open,
    closeModal,
    openModal
  }
}

export default useModal
